import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { QuillModule } from "ngx-quill";
import { ItemTypeMetadata } from '../../../../model/dyn-form/form-metadata/item-type-metadata.enum';
import { ItemMetadataBase } from '../../../../model/dyn-form/form-metadata/item/item-metadata.model';
import { LayoutTypeMetadata } from '../../../../model/dyn-form/form-metadata/layout-type-metadata.enum';
import { LayoutMetadataBase } from '../../../../model/dyn-form/form-metadata/layout/layout-metadata.model';
import { RowLayoutMetadataBase } from '../../../../model/dyn-form/form-metadata/layout/row-layout.metadata.model';
import { WebServiceLayoutMetadata } from '../../../../model/dyn-form/form-metadata/layout/webservice-layout-metadata.model';
import { HasShowHideLogic } from '../../../../model/dyn-form/form-metadata/logic/has-show-hide-logic.model';
import { ShowHideLogicMetadataBase } from '../../../../model/dyn-form/form-metadata/logic/show-hide-logic-metadata.model';
import { DynamicViewRowLayoutComponent } from '../dynamic-view-row-layout/dynamic-view-row-layout.component';

@Component({
    selector: 'app-dynamic-view-webservice-layout',
    templateUrl: './dynamic-view-webservice-layout.component.html',
    styleUrl: './dynamic-view-webservice-layout.component.scss',
    standalone: true,
    imports: [
    CommonModule,
    DynamicViewRowLayoutComponent,
    QuillModule
]
})
export class DynamicViewWebserviceLayoutComponent {

    @Input()
    set layout(p: LayoutMetadataBase) {
        this.webserviceLayout = <WebServiceLayoutMetadata>p
    }

    @Input()
    value: any

    webserviceLayout!: WebServiceLayoutMetadata

    fieldVisibility: Map<string, boolean> = new Map()
    
    
    constructor(private readonly changeDetectorRef: ChangeDetectorRef) { }

    ngOnInit(): void {

        if (this.value[this.webserviceLayout.fieldName]) {

            for (let item of this.webserviceLayout.items) {
                            
                if (item.type == LayoutTypeMetadata.Row) {

                    for (let rowItem of (<RowLayoutMetadataBase>item).items) {

                        if (rowItem.type == ItemTypeMetadata.CheckBox || rowItem.type == ItemTypeMetadata.MultiCheckBox || rowItem.type == ItemTypeMetadata.Radio || rowItem.type == ItemTypeMetadata.Select) {

                            let itemLogic = <HasShowHideLogic & ItemMetadataBase> rowItem

                            if (ShowHideLogicMetadataBase.hasAnyValue(itemLogic.logicShowHideField) == false) {
                                continue
                            }

                            this.checkFieldVisibility(itemLogic)

                        }

                    }

                }

            }

            this.changeDetectorRef.detectChanges()

        }

    }

    checkFieldVisibility(item: HasShowHideLogic & ItemMetadataBase) {

        if (this.value[this.webserviceLayout.fieldName]) {
        
            item.logicShowHideField.forEach(l => {

                if (l.ref == null) {
                    return
                }

                let val = this.value[this.webserviceLayout.fieldName][item.fieldName]

                if (item.type == ItemTypeMetadata.MultiCheckBox && val != undefined) {
                    val = val[<string> l.value]
                }

                if ((item.type == ItemTypeMetadata.MultiCheckBox && val) || val == l.value) {
                    this.fieldVisibility.set(<string> l.ref, true)
                } else {
                    this.fieldVisibility.set(<string> l.ref, false)
                }

                if (l.ref == null) {
                    return
                }

            })

            

        }     

    }

}
